import { IReward } from '@/states/reward.state';
import { MainTableColumn } from '@/components/company/table/MainTable';

export const rewardColumns: MainTableColumn[] = [
  {
    name: 'bonus_name',
    label: 'Nama Bonus',
    render: (_: unknown, row: IReward) => row.bonus_name ?? row.name ?? '-',
  },
  {
    name: 'bonus_period',
    label: 'Periode Bonus',
  },
  {
    name: 'bonus_target',
    label: 'Target',
    render: (_: unknown, row: IReward) => row.bonus_target ?? row.value ?? '-',
  },
  {
    name: 'bonus_amount',
    label: 'Besaran Bonus',
    render: (_: unknown, row: IReward) => {
      const amount = row.bonus_amount as unknown;
      if (typeof amount === 'number') {
        return (amount as number).toLocaleString('id-ID');
      }
      if (typeof amount === 'string' && amount.trim() !== '') {
        // Only thousand-format when the whole string is numeric; free-text
        // amounts (e.g. "2500000 (Tunai)", "10 juta") must show as-is. Number()
        // is strict and returns NaN on trailing non-numeric, unlike parseFloat.
        const num = Number(amount);
        if (!Number.isNaN(num)) return num.toLocaleString('id-ID');
        return amount;
      }
      return row.bonus_amount ?? '-';
    },
  },
  {
    name: 'category',
    label: 'Kategori Bonus',
    render: (_: unknown, row: IReward) => {
      if (row.category === 'level_perusahaan') return 'Level Perusahaan';
      if (row.category === 'level_jabatan') return 'Level Jabatan';
      return row.category || '';
    },
  },
];
